import { iConfigColumn } from '../../../shared/UITypes/types';
import { PRODUCTS_URL, WAREHOUSE_URL } from '../../../shared/UrlMap';

export const LIST_TABLE_NAME = 'stock-take-table';
export const LIST_PAGE_NAME = 'Stocktake';
export const LIST_CREATE_HINT = "Any warehouse location with stocktake WIP won't allow any movement";
export const STOCK_TAKE_COLUMNS: Array<iConfigColumn> = [
  {
    name: 'Stocktake No.',
    key: 'stocktakeNum',
    dataSource: ['id'],
    isCompulsory: true,
    isSortable: true,
    type: 'link',
    urlPrefix: '/b/stockTake',
    isSelected: true,
    group: '',
  },
  {
    name: 'Status',
    key: 'status',
    dataSource: ['status'],
    type: 'status',
    isSelected: true,
    group: '',
    isSortable: false,
  },
  {
    name: 'Scheduled At',
    key: 'scheduledAt',
    dataSource: ['scheduledAt'],
    type: 'datetime',
    isSelected: true,
    group: '',
    isSortable: false,
  },
  {
    name: 'Started At',
    key: 'startedAt',
    dataSource: ['startedAt'],
    type: 'datetime',
    isSelected: true,
    group: '',
    isSortable: false,
  },
  {
    name: 'Finished At',
    key: 'finishedAt',
    dataSource: ['finishedAt'],
    type: 'datetime',
    isSelected: true,
    group: '',
    isSortable: false,
  },
  {
    name: 'For Location',
    key: 'warehouseLocation.locationCode',
    dataSource: ['warehouseLocation.id'],
    type: 'link',
    urlPrefix: WAREHOUSE_URL,
    isSelected: true,
    group: '',
    isSortable: false,
  },
  {
    name: 'Location Path',
    key: 'warehouseLocationId',
    dataSource: ['warehouseLocationId'],
    type: 'text-idNameMap',
    isSelected: true,
    group: '',
    isSortable: false,
  },
  {
    name: 'Created',
    key: 'createdAt',
    dataSource: ['createdBy.firstName'],
    type: 'history',
    group: '',
    isSortable: false,
  },
  {
    name: 'Updated',
    key: 'updatedAt',
    dataSource: ['updatedBy.firstName'],
    type: 'history',
    isSelected: true,
    group: '',
    isSortable: false,
  },
  {
    name: '',
    key: 'operation',
    dataSource: [],
    type: 'operation',
    isCompulsory: true,
    isSelected: true,
    group: '',
  },
];

export const DETAIL_PREFIX = 'Stocktake';
export const DETAIL_PAGE_NAME = 'Stocktakes';
export const SUPPOSED_ITEMS_TITLE = 'Current Items in ';
export const SUPPOSED_ITEM_TABLE_COLUMNS: Array<iConfigColumn> = [
  {
    name: 'Product',
    key: 'product.productCode',
    dataSource: ['product.id', 'product.name'],
    isCompulsory: true,
    type: 'link-secondary',
    urlPrefix: PRODUCTS_URL,
  },
  {
    name: 'Batch/Lot No.',
    key: 'reference',
    dataSource: ['reference'],
    type: 'text',
  },
  {
    name: 'Quantity',
    key: 'qty',
    dataSource: ['qty'],
    type: 'text',
  },
  {
    name: 'Unit',
    key: 'product.measurement.shortName',
    dataSource: ['product.measurement.shortName'],
    type: 'text',
  },
];
export const FOUND_ITEMS_TITLE = 'Found Items in ';
export const FOUND_ITEM_TABLE_COLUMNS: Array<iConfigColumn> = [
  {
    name: 'Product',
    key: 'product.name',
    dataSource: ['product.productCode'],
    type: 'edit-trigger',
  },
  {
    name: 'Batch/Lot No.',
    key: 'reference',
    dataSource: ['reference'],
    type: 'text',
  },
  {
    name: 'Quantity',
    key: 'qty',
    dataSource: ['qty'],
    type: 'text',
  },
  {
    name: 'Unit',
    key: 'product.measurement.shortName',
    dataSource: ['product.measurement.shortName'],
    type: 'text',
  },
  {
    name: '',
    key: 'delete',
    type: 'delete',
    dataSource: ['id'],
  },
];

export const FINISHING_WARNING_TITLE =
  'This process can NOT be reversed, please confirm all the items below before you continue';
export const FINISHING_WARNING_BOTTOM = 'This process can NOT be reversed';

export const FINISH_PREVIEW_TABLE_COLUMNS = [
  {
    name: 'Product',
    key: 'product.productCode',
    dataSource: ['product.name'],
    type: 'text-secondary',
  },
  {
    name: 'Batch/Lot No.',
    key: 'reference',
    dataSource: ['reference'],
    type: 'text',
  },
  {
    name: 'Quantity',
    key: 'qty',
    dataSource: ['qtyFrom'],
    type: 'text-arrow-text',
  },
  {
    name: 'Unit',
    key: 'product.measurement.shortName',
    dataSource: ['product.measurement.shortName'],
    type: 'text',
  },
  {
    name: 'New Location',
    key: 'toWarehouseLocation.locationCode',
    type: 'text-secondary',
    dataSource: ['toWarehouseLocation.name'],
  },
];

export const FINISHED_STOCK_TAKE_ITEM_TABLE = 'finished-stockTakeItem-table';
